import { Link, Navigate, useParams } from 'react-router-dom';
import LandingAtmosphere from '../components/ui/LandingAtmosphere';
import ParrotEmblem from '../components/ui/ParrotEmblem';
import LegalMarkdown from '../components/legal/LegalMarkdown';
import { getLegalDocument, LEGAL_OPERATOR } from '../content/legalDocuments';
import { getLegalLinks } from '../config/legal';

export default function LegalDocument() {
  const { slug } = useParams<{ slug: string }>();
  const doc = getLegalDocument(slug);
  const links = getLegalLinks();

  if (!doc) {
    return <Navigate to="/legal/terms" replace />;
  }

  return (
    <div className="relative min-h-screen bg-[var(--bm-landing-bg)] text-[var(--bm-landing-ink)]">
      <LandingAtmosphere className="fixed inset-0" />
      <header className="relative z-10 border-b border-slate-200/80 bg-white/80 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 px-4 py-4 sm:px-6">
          <Link to="/login" className="flex items-center gap-2 text-sm font-semibold">
            <ParrotEmblem className="h-8 w-8" />
            BirdMan
          </Link>
          <nav className="flex flex-wrap gap-4 text-sm">
            {links.map((link) => (
              <Link
                key={link.url}
                to={link.url}
                className={
                  link.url.endsWith(`/${doc.slug}`)
                    ? 'font-semibold text-teal-800'
                    : 'text-slate-600 hover:text-teal-800'
                }
              >
                {link.label}
              </Link>
            ))}
            <Link to="/login" className="text-slate-600 hover:text-teal-800">
              Back to login
            </Link>
          </nav>
        </div>
      </header>
      <main className="relative z-10 mx-auto max-w-3xl px-4 py-12 sm:px-6">
        <p className="text-xs uppercase tracking-wide text-slate-500">
          Effective {LEGAL_OPERATOR.EFFECTIVE_DATE}
        </p>
        <LegalMarkdown markdown={doc.markdown} />
        <p className="mt-12 text-sm text-slate-500">
          Questions: {LEGAL_OPERATOR.SUPPORT_EMAIL}
        </p>
      </main>
    </div>
  );
}
